import { Component, OnInit } from '@angular/core';
import { UnitsService } from 'src/app/services/units.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AddunitComponent } from '../addunit/addunit.component';
import { Router } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { UnitBlockComponent } from '../unit-block/unit-block.component';
import {PageEvent, MatPaginatorModule} from '@angular/material/paginator';


@Component({
  selector: 'app-mange-units',
  templateUrl: './mange-units.component.html',
  styleUrls: ['./mange-units.component.css']
})
export class MangeUnitsComponent implements OnInit {

  unitName: any = ""
  units_arr: any = []
  multiUnits = false;
  checkBoxStatus = false
  typesArr:any = []
  typeName = "Choose Type"
  curent_page = 0
  pageIndex = 0
  page_size = 200
  constructor(private rest: UnitsService,
    private route: Router,
    private main : MainService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.allUnits()
    // this.searchUnit()
    this.gettypes()

  }

  allUnits(){
    this.rest.allUnitsPagnation(this.curent_page,this.page_size).subscribe((res:any) => {
      console.log("pagnation",res)
      this.units_arr = res
    })
  }

  searchUnit() {
    if(this.unitName == ''){
      this.allUnits()
    }else {
      this.checkBoxStatus = false
      this.typeName = "Choose Type" 
      this.rest.searchunit(this.unitName).subscribe((res: any) => {
        console.log(res)
        this.units_arr = res
      })
    }
   
  }
  searchByType(type: any) {
    this.units_arr = []
    this.typeName = type
    this.rest.allUnits(this.unitName, type).subscribe((res: any) => {
      console.log(res)
      if(res != null){
        res.forEach((element:any) => {
          this.units_arr.push ({
            name : element,
            type : type
          })
        });
      }else {
      this.units_arr = res
      }
    })
  }

  unitDetails(name: string) {
    this.route.navigate(['pages/unit_details', name])
  }

  gettypes(){
    this.rest.getTypes().subscribe((res :any) => {
      console.log(res)
      this.typesArr = res.children
    })
  }

  add_unit() {
    const dialogRef = this.dialog.open(AddunitComponent);

    dialogRef.afterClosed().subscribe((result :any) => {
      if(result){
        this.rest.addunit(result).subscribe((res :any) => {
          console.log(res)
          this.main.SuccessToast("Unit Added Successfully")
        },(err:any) => {
          this.main.erorrToast("Something wrong")
          console.log(err)
        })
      }
      console.log(result)
     
    });
  }


  blockUnitGates() {
    const dialogRef = this.dialog.open(UnitBlockComponent ,{
      width : "400px"
    });

    dialogRef.afterClosed().subscribe((result :any) => {
      if(result){
        let ids:any = []
        this.unit_blocked.forEach((element:any) => {
          ids.push(element.id)
        });

        let data =  {
          "gates": result,
          "units": ids
        }

        this.rest.blockUnitForGate(data).subscribe((res:any) => {
          console.log(res)
          this.main.SuccessToast('units blocked')
          this.searchUnit()
        })
       console.log(result)
      }
     
    });
  }


  unit_blocked:any = [] 
  unit_blocked_btn_status = false
  inputcheckBox(value:any,item:any ,index:any){
    this.unit_blocked_btn_status = true
    if(this.unit_blocked.includes(item)){
      this.unit_blocked.splice(index, 1);
    }else {
      this.unit_blocked.push(item)
    }
    if(this.unit_blocked.length != 0){
      this.unit_blocked_btn_status = true
    }else {
      this.unit_blocked_btn_status = false
    }
    console.log(this.unit_blocked)
  }

  handlePageEvent(e: PageEvent) {
    this.pageIndex = e.pageIndex
    this.curent_page = e.pageIndex + 1
    this.page_size = e.pageSize
    this.allUnits()
    console.log(e)
  }

}
